import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { cn } from "@/lib/utils";

const NAV = [
    { label: "Solutions", href: "#solutions" },
    { label: "Modules WP", href: "#modules" },
    { label: "L'histoire", href: "#histoire" },
    { label: "Avantages", href: "#avantages" },
    { label: "Comment ça marche", href: "#process" },
    { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header id="top" className={cn(
            "fixed inset-x-0 top-0 z-50 transition-all duration-300",
            scrolled ? "py-3" : "py-5"
        )}>
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className={cn(
                    "flex items-center justify-between gap-4 rounded-2xl px-4 py-2.5 transition-all duration-300",
                    scrolled ? "glass shadow-card-elevated" : "bg-transparent"
                )}>
                    <Logo />

                    <nav className="hidden items-center gap-1 lg:flex">
                        {NAV.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                className="rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>

                    <div className="hidden items-center gap-2 md:flex">
                        <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground" asChild>
                            <a href="#solutions">Se connecter</a>
                        </Button>
                        <Button size="sm" className="bg-gradient-primary text-primary-foreground shadow-glow hover:opacity-95" asChild>
                            <a href="#solutions" className="inline-flex items-center gap-1">
                                Découvrir la suite
                                <ArrowUpRight className="h-4 w-4" />
                            </a>
                        </Button>
                    </div>

                    <button
                        type="button"
                        aria-label="Menu"
                        onClick={() => setOpen((v) => !v)}
                        className="flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-card text-foreground lg:hidden"
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>

                {/* Mobile */}
                {open && (
                    <div className="mt-2 overflow-hidden rounded-2xl glass p-2 lg:hidden">
                        <nav className="flex flex-col">
                            {NAV.map((item) => (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    onClick={() => setOpen(false)}
                                    className="rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground"
                                >
                                    {item.label}
                                </a>
                            ))}
                            <div className="mt-2 grid grid-cols-2 gap-2 p-1">
                                <Button variant="outline" size="sm" asChild>
                                    <a href="#solutions">Se connecter</a>
                                </Button>
                                <Button size="sm" className="bg-gradient-primary text-primary-foreground" asChild>
                                    <a href="#solutions">Découvrir</a>
                                </Button>
                            </div>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
}
